import { useQuery } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import axiosInstance from 'src/utils/axios';

export interface ManagementCompanyObject {
  companyName: string;
  companyId: number;
}

export type ManagementCompanyResponse = ManagementCompanyObject[];

async function fetchManagementCompanies(): Promise<ManagementCompanyResponse> {
  const response = await axiosInstance.get<ManagementCompanyResponse>(api.getManagementCompanies);
  return response.data;
}

export function useManagementCompaniesQuery(enabled = false) {
  return useQuery({
    queryKey: queryKeys.company.managementCompanies(),
    queryFn: fetchManagementCompanies,
    enabled,
  });
}
